import React, { useState } from 'react';
import BlueDotsBackground from '../BlueDotsBackground';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add login logic here
    alert('Login submitted');
  };

  return (
    <>
      <BlueDotsBackground />
      <div className="min-h-screen text-white flex flex-col items-center justify-center px-4">
        <div className="bg-gray-800 p-8 rounded-2xl shadow-xl w-full max-w-md mb-8">
          <h2 className="text-3xl font-semibold mb-6 text-center">
            Sign In to Kernel
          </h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 py-3 rounded-xl font-medium transition duration-200"
            >
              Login
            </button>
          </form>
          <p className="text-sm text-center mt-4">
            Don’t have an account?{' '}
            <a href="/contact" className="text-blue-400 hover:underline">
              Register here
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
